import {
  IsInt,
  IsObject,
  IsOptional,
  IsDate,
  IsDecimal
} from 'class-validator';
import { BaseDto } from '../base.dto';
import type { MerchantDto } from '../merchant.dto';
import type { GiftCardBenefitFrequencyDto } from './giftCardBenefitFrequency.dto';

export class GiftCardBenefitSetupDto extends BaseDto {
  @IsOptional()
  @IsDecimal()
  balanceTopUpTo?: number;

  @IsOptional()
  @IsInt()
  frequencyId?: number;

  @IsOptional()
  @IsDate()
  lastTopUp?: Date;

  /* Relationships */

  @IsOptional()
  @IsObject()
  merchant?: MerchantDto;

  @IsOptional()
  @IsObject()
  frequency?: GiftCardBenefitFrequencyDto;
  
  /* Virtual columns */

  @IsOptional()
  @IsDate()
  nextTopUpDate?: Date;
}
